export const SSBoolean = 'System.Boolean';
export const SSByte = 'System.Byte';
export const SSChar = 'System.Char';
export const SSString = 'System.String';
export const SSDateTime = 'System.DateTime';
export const SSInt32 = 'System.Int32';
export const SSInt16 = 'System.Int16';
export const SSInt64 = 'System.Int64';
export const SSSingle = 'System.Single';
export const SSDouble = 'System.Double';
export const SSDecimal = 'System.Decimal';
